import React from "react";
import { Info } from "@phosphor-icons/react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const isDemoMode = () => localStorage.getItem("ht_demo_mode") === "1";

// Formatter EUR standard
const EUR_FMT = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" });

/**
 * Formatta un prezzo in €. In modalità demo, restituisce "€ ***" per non
 * svelare i prezzi effettivi dei servizi ai visitatori demo.
 * Usare SOLO per prezzi di catalogo/servizio (professional_price, base_price,
 * addebito plafond, chained totals). Per valori che l'utente ha appena digitato
 * o derivati dal suo input (es. totale IVA di un preventivo che sta creando)
 * usare direttamente `fmt()` — l'utente sa già cosa ha inserito.
 */
export const fmtPrice = (n) => (isDemoMode() ? "€ ***" : EUR_FMT.format(n || 0));

export function DemoBanner() {
  if (!isDemoMode()) return null;
  return (
    <div className="mb-6 rounded-lg border-2 border-dashed border-purple-400 bg-purple-50 px-4 py-3 text-sm flex items-start gap-3" data-testid="demo-banner">
      <span className="text-2xl">🎬</span>
      <div>
        <div className="font-semibold text-purple-900">Modalità Demo attiva — Professionista di prova</div>
        <div className="text-purple-800 text-xs mt-0.5">
          Stai esplorando Housetag con dati fittizi (Studio Rossi, prezzi €0). Modifiche non permanenti.
          {" "}<button onClick={() => { localStorage.clear(); window.location.href = "/"; }} className="underline font-medium">Esci dalla demo</button>
        </div>
      </div>
    </div>
  );
}

export function HelpTip({ text, side = "top" }) {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-purple-100 text-purple-700 hover:bg-purple-200 transition-colors align-middle ml-1.5" data-testid="help-tip">
            <Info size={11} weight="bold" />
          </button>
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-xs text-xs leading-relaxed">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
